import React from "react";

// Local Libraries
import phrasebookLoad from "../../../../i18n";
import { gisRoutes } from "../../../../routes/routes";
import * as token from "../../../../helpers/token";
import { accountTypesConstants } from "../../../../constants";

//components
import { CancelButton } from "../../../../components/SkyFramework/Buttons";

// Constants
const phrasebook = phrasebookLoad();

function ifCities(cities, actualState, handleChange) {
  if (cities) return <div className="col-xs-12 col-sm-6 col-md-4">
    <div className="form-col">
      <label>
        {phrasebook.references.city}
        <i
          className="info-icon ml-auto mt-0 tooltip tooltip-left"
          data-tooltip={phrasebook.tooltip.city}
        ></i>
      </label>
      <select onChange={handleChange} id="city" name="city">
        <option value="">
          {phrasebook.filters.select_an_option}
        </option>
        {cities.data.map((city, index) => {
          if (actualState.city === city) return (<option value={city} selected>{city}</option>);
          else return (<option value={city}>{city}</option>);
        })}
      </select>
      {/* {['SIP Trunking', 'DID'].includes(actualState.service_type) ? <>
        <label for="e-input-3"><strong>Specific City</strong>  <i className="info-icon tooltip tooltip-bottom tooltip-xs-right pl-1" data-tooltip="All the commerical terms and conditions are subject to further confirmation."></i></label>
        <input type="text"
          placeholder="Select a city"
          id="city_specific"
          name="city_specific"
          value={actualState.city_specific}
          onChange={handleChange}
          disabled={actualState.city ? true : false} />
      </> : null} */}
    </div>
  </div>
}

function ifCustomers(customers, actualState, handleChange) {
  if (customers) return (<div className="row row-sm">
    <div className="col-xs-12 col-sm-6 col-md-4">
      <div className="form-col">
        <label>
          {phrasebook.headerlinks.customers}
          <i
            className="info-icon ml-auto mt-0 tooltip tooltip-left"
            data-tooltip={phrasebook.tooltip.customer_for}
          ></i>
        </label>
        <select id="customer_id" name="customer_id" onChange={handleChange}>
          <option value="">
            {phrasebook.filters.select_an_option}
          </option>
          {customers.data.map((customer) => {
            if (actualState.customer_id === customer.id) return (<option value={customer.id} selected>{customer.name}</option>);
            else return (<option value={customer.id}>{customer.name}</option>);
          })}
        </select>
      </div>
    </div>
  </div>)
  else return null

}

export default class NumberDetails extends React.Component {
  account_type_logged = accountTypesConstants[token.loggedAccountType()];

  continue = (e) => {
    e.preventDefault();
    this.props.nextStep();
  };

  render() {
    const { actualState, customers, citiesCoverage, serviceTypes, jurisdictionCoverage, nextStep, handleChange } = this.props;
    return (
      <>
        <form>
          {['SIP Trunking', 'DID'].includes(actualState.service_type) && actualState.jurisdiction ? <div class="alert alert-warning"><p>{phrasebook.orders.city_option} </p></div> : null}
          {ifCustomers(customers, actualState, handleChange)}
          <div className="filter-row d-flex flex-column flex-md-row align-items-end">
            <div className="flex-1 w-100">
              <div className="row row-sm">
                <div className="col-xs-12 col-sm-6 col-md-4">
                  <div className="form-col">
                    <label>
                      {phrasebook.numbers.type_of_number}
                      <i
                        className="info-icon ml-auto mt-0 tooltip tooltip-left"
                        data-tooltip={phrasebook.tooltip.service_number_type}
                      ></i>
                    </label>
                    <select id="service_type" name="service_type" onChange={handleChange}>
                      <option value="">
                        {phrasebook.filters.select_an_option}
                      </option>
                      {serviceTypes.map((service_type) => {
                        if (actualState.service_type === service_type.value) return (<option value={service_type.value} selected>{service_type.label}</option>);
                        else return (<option value={service_type.value}>{service_type.label}</option>);
                      })}
                    </select>
                  </div>
                </div>
                <div className="col-xs-12 col-sm-6 col-md-4">
                  <div className="form-col">
                    <label>
                      {phrasebook.profile.jurisdiction}
                      <i
                        className="info-icon ml-auto mt-0 tooltip tooltip-left"
                        data-tooltip={phrasebook.tooltip.jurisdiction}
                      ></i>
                    </label>
                    <select onChange={handleChange} id="jurisdiction" name="jurisdiction">
                      <option value="">
                        {phrasebook.filters.select_an_option}
                      </option>
                      {jurisdictionCoverage.data.map((jurisdiction) => {
                        if (actualState.jurisdiction === jurisdiction) return (<option value={jurisdiction} selected> {jurisdiction}</option>);
                        else return (<option value={jurisdiction}> {jurisdiction}</option>);
                      })}
                    </select>
                  </div>
                </div>
                {ifCities(citiesCoverage, actualState, handleChange)}
              </div>
            </div>
          </div>

          <div className="box-actions-footer">
            <CancelButton
              link={gisRoutes.dashboard[this.account_type_logged]}
              title={phrasebook.common.cancel}
            />
            <button
              className="btn btn-main"
              onClick={
                // this.handleOnNext
                nextStep
              }
            >
              {phrasebook.common.next}{" "}
            </button>
          </div>
        </form>
      </>
    );
  }
}
